// Google Analytics 4 (gtag.js) con gestione del consenso cookie (GDPR)
// Attivo SOLO in produzione (sedio.it), SOLO se e' impostato l'ID misurazione
// e SOLO dopo il consenso esplicito dell'utente.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const PROD_HOSTS = ["sedio.it", "www.sedio.it"];
export const CONSENT_KEY = "sedio_cookie_consent";

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* no-op */
  }
}

function isProductionHost() {
  if (typeof window === "undefined") return false;
  return PROD_HOSTS.includes(window.location.hostname);
}

export function analyticsEnabled() {
  if (!GA_ID) return false;
  if (!isProductionHost()) return false;
  if (getConsent() !== "granted") return false;
  return true;
}

export function initGA() {
  if (!analyticsEnabled()) return;
  if (document.getElementById("ga4-src")) return;

  const script = document.createElement("script");
  script.async = true;
  script.id = "ga4-src";
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // Gestiamo noi i page_view (anche sui cambi di rotta della SPA)
  window.gtag("config", GA_ID, { send_page_view: false });
}

// Evento generico GA4 (es. apertura video, click CTA)
export function trackEvent(name, params = {}) {
  if (!analyticsEnabled() || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}

export function trackPageView(path) {
  if (!analyticsEnabled() || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
